import { render } from "./ModalNewUser.vue?vue&type=template&id=94964412&scoped=true"
import script from "./ModalNewUser.vue?vue&type=script&lang=js"
export * from "./ModalNewUser.vue?vue&type=script&lang=js"

import "./ModalNewUser.vue?vue&type=style&index=0&id=94964412&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94964412"]])

export default __exports__